<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Ao6jaN/tc-custom/9781421406633.jpg?1703821035196" alt="This image is the cover for the book Anna Seward and the End of the Eighteenth Century"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anna Seward and the End of the Eighteenth Century
      </h1>
      <p class="bookDescription body article font2">
        <b>A critical study of the prominent British poet’s work.</b><br/><br/>Anna Seward and her career defy easy placement into the traditional periods of British literature. Raised to emulate the great poets John Milton and Alexander Pope, maturing in the Age of Sensibility, and publishing during the early Romantic era, Seward exemplifies the eighteenth-century transition from classical to Romantic. Claudia Thomas Kairoff’s excellent critical study offers fresh readings of Anna Seward's most important writings and firmly establishes the poet as a pivotal figure among late-century British writers.<br/><br/>Reading Seward’s writing alongside recent scholarship on gendered conceptions of the poetic career, patriotism, provincial culture, sensibility, and the sonnet revival, Kairoff carefully reconsiders Seward's poetry and critical prose. Written as it was in the last decades of the eighteenth century, Seward’s work does not comfortably fit into the dominant models of Enlightenment-era verse or the tropes that characterize Romantic poetry. Rather than seeing this as an obstacle for understanding Seward’s writing within a particular literary style, Kairoff argues that this allows readers to see in Seward's works the eighteenth-century roots of Romantic-era poetry.<br/><br/>Arguably the most prominent woman poet of her lifetime, Seward’s writings disappeared from popular and scholarly view shortly after her death. After nearly two hundred years of critical neglect, Seward is attracting renewed attention, and with this book Kairoff makes a strong and convincing case for including Anna Seward’s remarkable literary achievements among the most important of the late eighteenth century.<br/><br/><b>“Professor Kairoff achieves her goal of providing “fresh readings, in a richer context,” which will go a long way toward reestablishing Seward’s importance. The book is a significant contribution to literary scholarship and will be widely read, cited, and admired.” —Paula R. Feldman</b><br/><br/><b>“This lucid, stimulating study will challenge traditional notions not only of Seward but also of the interstice of Romanticism and late-century women authors.” —<i>Choice</i></b><br/><br/><b>“Kairoff effectively demonstrates the quality of Seward’s work, and articulates some of the ways in which a reappraisal of Seward might enrich our understanding of both eighteenth-century and Romantic-era literary cultures, and our conception of the writing practices of both male and female authors.” —<i>Years Work in English Studies</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claudia T. Kairoff
      </h2>
      
      <p class="authorDescription body article">Claudia Thomas Kairoff is a professor of English at Wake Forest University, coeditor of “More Solid Learning”: New Perspectives on Alexander Pope’s Dunciad, and author of Alexander Pope and His Eighteenth-Century Women Readers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0487c2a4